import React from 'react'

import modalStyles from './../PartnerIdModalDialog.module.scss'

interface IProps {
  requestId: number
  requestSpecializationName: string
}

export const Warning = ({ requestId, requestSpecializationName }: IProps) => {
  return (
    <div>
      <b className={modalStyles.warning}>Warning!</b>
      <p>
        This partner already has a pending onboarding request <b>{requestId}</b> —{' '}
        <b>{requestSpecializationName}</b>.
      </p>
      <ul className={modalStyles.advicesContainer}>
        <li>
          In case you need to work on the current request, reject first {requestId} and then update
          the PartnerID in this request.
        </li>
        <li>Otherwise, reject the current request and continue working on {requestId}.</li>
      </ul>
    </div>
  )
}
